// extracted by mini-css-extract-plugin
export default {"medical-prescription":"medical-prescription","heading-popover":"heading-popover","popover-icon":"popover-icon","form-switch-holder":"form-switch-holder"};